

















import { InstanceResolver } from '@/util/instanceResolver'
import { URL } from '@/util/url'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import HostPageLinkMixin from '@/mixin/HostPageLink'
import { getCreditcardPaymentProvierServiceConfig } from '@/services/payment'

@Component({
  mixins: [
    HostPageLinkMixin,
  ],
})
export default class CreditCardDescription extends Vue {

  get enableCardListImage(): string {
    return `/assets-proxy/images/creditcard/${getCreditcardPaymentProvierServiceConfig().provider}/enable-card-list.gif`
  }

  get faq(): string {
    const path = '/faq'

    return InstanceResolver.isSingle()
      ? path
      : URL.join('/mycolor', path)
  }
}
